import { Request } from "@/common/util";
import Cookies from "js-cookie";

/**
 * Download Survey PDF
 * @param payload {username,id}
 */
export const downloadSurveyPDF = (payload) => {
  let token = Cookies.get("token");

  return Request({
    path: `/download-pdf`,
    method: "POST",
    header: {
      Authorization: token,
    },
    data: payload,
  });
};

/**
 * Get user surveys
 * @param id user id
 */
export const getSurveys = (id) => {
  let token = Cookies.get("token");

  return Request({
    path: `/users/${id}/surveys/all`,
    method: "GET",
    header: {
      Authorization: token,
    },
  });
};

/**
 * Create user survey
 * @param payload survey object information
 */
export const createSurvey = (payload) => {
  let token = Cookies.get("token");
  return Request({
    path: `/users/surveys/create`,
    method: "POST",
    data: payload,
    header: {
      Authorization: token,
    },
  });
};

/***
 * Update user survey
 * @param id survey id
 * @param payload survey object information
 */
export const updateSurvey = (id, payload) => {
  let token = Cookies.get("token");
  return Request({
    path: `/users/surveys/${id}/edit`,
    method: "POST",
    data: payload,
    header: {
      Authorization: token,
    },
  });
};

/***
 * Delete user survey
 * @param id survey id
 *
 */
export const deleteSurvey = (id) => {
  let token = Cookies.get("token");
  return Request({
    path: `/users/surveys/${id}/delete`,
    method: "DELETE",
    header: {
      Authorization: token,
    },
  });
};

/**
 * Get survey base on survey tag id
 * @param userId user id
 * @param surveyId survey tag id
 */
export const getSurvey = (userId, surveyId) => {
  let token = Cookies.get("token");
  return Request({
    path: `/users/surveys/${surveyId}?user=${userId}`,
    method: "GET",
    header: {
      Authorization: token,
    },
  });
};
